import { Money, ProductConditionCode, UrgencyCode } from "../../common/models/CommonModels"
import { Page, QueryBase } from "../../shared/models/models";

export interface AdminRfqsState {
  query: AdminRfqsQuery;
  rfqs?: Page<AdminRfq>;
  rfq?: AdminRfq;
  manufacturers: ManufacturerReference[],
  categories: CategoryReference[],
  loading: boolean;
  success?: string;
  error: any;
}

export interface AdminRfq {
  id: string;
  number: string;
  productNumber: string;
  productAlternativeNumber: string;
  maxUnitPrice: Money;
  quantity: number;
  description: string;
  urgencyCode: UrgencyCode;
  isPrivate: boolean;
  lastCall: Date;
  statusCode: RfqStatusCode;
  createdDate: Date;
  buyer: CustomerReference;
  category: CategoryReference;
  manufacturer: ManufacturerReference;
  productConditionCodes: ProductConditionCode;
}

export interface ManufacturerReference {
  id: string;
  name: string;
}

export interface CategoryReference {
  id: string;
  name: string;
}

export interface CustomerReference {
  id: string;
  name: string;
  countryId: number;
  countryName: string;
}

export interface AdminRfqsQuery extends QueryBase<AdminRfqQueryParameter> {
  search?: string;
}

export enum RfqStatusCode {
  open = 1,
  closed = 2,
  confirmed = 3,
  archived = 4
}

export enum AdminRfqQueryParameter {
  createdDate = 1,
  modifiedDate = 2,
  countryName = 3,
  companyName = 4,
  productName = 5,
  productNumber = 6,
  quantity = 7,
  price = 8,
  visibility = 9,
  status = 10
}

class AdminRfqStatuses {
  private readonly map = {} as any;

  constructor() {
    this.map[RfqStatusCode.open] = "Open";
    this.map[RfqStatusCode.closed] = "Closed";
    this.map[RfqStatusCode.confirmed] = "Confirmed";
    this.map[RfqStatusCode.archived] = "Archived";
  }

  adminRfqStatus = (code: RfqStatusCode) => {
    return this.map[code] || "";
  };
}

export const { adminRfqStatus } = new AdminRfqStatuses();

export const isAdminRfqsQueryEmpty = (query: AdminRfqsQuery): boolean => {
  return !query.search;
};
